const REPEAT_COUNT = 4;

const EDGE_FADE_MASK =
  'linear-gradient(to right, transparent 0, #000 6%, #000 94%, transparent 100%)';

function MegaphoneIcon() {
  return (
    <svg className="h-4 w-4 sm:h-[18px] sm:w-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13H5a4 4 0 010-8h.436c1.927 0 3.86-.392 5.564-1.165L18 1v16l-7-2.835C9.296 13.392 7.363 13 5.436 13z"
      />
    </svg>
  );
}

function SparkleIcon() {
  return (
    <svg
      className="announcement-sparkle h-3.5 w-3.5 shrink-0 text-[#B539FD] sm:h-4 sm:w-4"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M12 2c.4 4.6 2.4 6.6 7 7-4.6.4-6.6 2.4-7 7-.4-4.6-2.4-6.6-7-7 4.6-.4 6.6-2.4 7-7z" />
      <path d="M19 14c.2 2.1 1 2.9 3 3-2 .2-2.8 1-3 3-.2-2-1-2.8-3-3 2-.1 2.8-.9 3-3z" opacity="0.6" />
    </svg>
  );
}

function AnnouncementGroup({ text, hidden = false }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {Array.from({ length: REPEAT_COUNT }, (_, index) => (
        <span key={index} className="flex items-center gap-3 whitespace-nowrap pr-10 sm:gap-4 sm:pr-16">
          <SparkleIcon />
          <span className="bg-gradient-to-r from-[#9369CC] via-[#B539FD] to-[#6A74E1] bg-clip-text text-transparent">
            {text}
          </span>
        </span>
      ))}
    </div>
  );
}

function AnnouncementBar({ text }) {
  const message = text?.trim();
  if (!message) return null;

  const durationSeconds = Math.min(90, Math.max(25, message.length * 0.6));

  return (
    <div className="px-4 pt-5 sm:px-6 lg:px-8" role="region" aria-label="Announcement">
      <span className="sr-only">{message}</span>
      <div className="mx-auto flex max-w-7xl items-center gap-3 sm:gap-4" aria-hidden>

        <div
          className="announcement-marquee min-w-0 flex-1 overflow-hidden py-1 text-sm font-semibold tracking-wide sm:text-base lg:text-[17px]"
          style={{ maskImage: EDGE_FADE_MASK, WebkitMaskImage: EDGE_FADE_MASK }}
        >
          <div
            className="announcement-marquee__track flex w-max"
            style={{ animationDuration: `${durationSeconds}s` }}
          >
            <AnnouncementGroup text={message} />
            <AnnouncementGroup text={message} hidden />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnnouncementBar;
